import * as actionTypes from "../actions/actionTypes";

const initialState = {
  // token: null,
  // userId: null,
  isAuth: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_AUTH:
      console.log("dddd", action);
      return {
        ...state,
        isAuth: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
